<template>
  <div>
    <div v-show="loading"></div>
    <div v-show="!loading" id="app">
      <header>
        <img :src="config.logo_pic" alt="" class="logo" />

        <VLanguageDropdown />
      </header>

      <main>
        <div class="content">
          <div v-for="(element, i) in body" :key="i">
            <p v-if="element.type === 'title'" class="title" :style="{ color: element.color }">
              {{ t(`body.${element.label}`) }}
            </p>

            <p v-else-if="element.type === 'text'" class="text">
              {{ t(`body.${element.label}`) }}
            </p>

            <img v-else-if="element.type === 'img'" :src="t(`body.${element.href}`)" alt="" class="img" />

            <button
              v-else-if="element.type === 'btn'"
              @click="onClickButton(t(`body.${element.url}`))"
              :style="{ 'background-color': element.color }"
            >
              {{ t(`body.${element.label}`) }}
            </button>

            <div v-else-if="element.type === 'padding'" :style="{ height: element.px }"></div>

            <div v-else-if="element.type === 'video'" style="position: relative; padding-top: 56.25%; width: 100%">
              <iframe
                :src="t(`body.${element.href}`)"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture; encrypted-media; allowfullscreen;"
                style="position: absolute; width: 100%; height: 100%; top: 0; left: 0"
              ></iframe>
            </div>
          </div>
        </div>
      </main>
    </div>

    <VFooter v-show="!loading" :config="config" />
  </div>
</template>

<script>
import { defineComponent, ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import VLanguageDropdown from '@/components/VLanguageDropdown.vue'
import VFooter from '@/components/VFooter.vue'

export default defineComponent({
  name: 'MainView',
  components: {
    VLanguageDropdown,
    VFooter
  },

  setup() {
    const { t } = useI18n()
    const store = useStore()
    const { config } = store.state.main.config

    const loading = ref(true)

    onMounted(() => {
      window.onload = () => {
        loading.value = false
      }
    })

    setTimeout(() => {
      if (loading.value) {
        loading.value = false
      }
    }, 1000)

    const body = JSON.parse(config.body || '{}')

    const onClickButton = href => {
      window.location.href = href
    }

    const setRedirectTimeout = () => {
      const redirectData = JSON.parse(config.redirect || '{}')

      if (redirectData.redirect_time && redirectData.redirect_url) {
        setTimeout(() => {
          window.location.href = redirectData.redirect_url
        }, redirectData.redirect_time)
      }
    }

    if ('redirect' in config) {
      setRedirectTimeout()
    }

    return {
      config,
      body,
      loading,
      onClickButton,
      t
    }
  }
})
</script>

<style lang="scss" scoped>
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  align-items: center;
  width: 100%;

  header,
  main {
    width: 100%;
    max-width: 800px;
    padding: 1rem 2rem;
  }
}

header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .logo {
    max-height: 100px;
    user-select: none;
  }
}

main {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 6rem;

  .content {
    text-align: center;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .title {
      color: var(--font_main);
      font-size: 28px;
      font-weight: 600;
    }

    .text {
      color: var(--font_second);
    }

    img {
      user-select: none;
      max-width: 100%;
      border-radius: 16px;
    }

    button {
      max-width: 470px;
      width: 100%;
      padding: 0.5rem 1rem;
      font-size: 20px;
      font-weight: 600;
      border: none;
      height: 60px;
      border-radius: 16px;
      background-color: var(--btn);
      color: var(--font_main);
      cursor: pointer;
      transition: transform 0.3s ease;
      outline: none;
      font-family: Montserrat, Helvetica, Arial, sans-serif;

      &:hover {
        transform: scale(0.99);
      }

      &:active {
        transform: scale(1);
      }
    }
  }
}

@media (max-width: 768px) {
  header .logo {
    max-height: 60px;
  }
}
</style>
